var render = function render(){var _vm=this,_c=_vm._self._c;return _c('deploy-details',{attrs:{"page":_vm.page,"items-per-page":_vm.itemsPerPage,"search":_vm.search,"is-finished":String(_vm.isFinished),"is-canceled":String(_vm.isCanceled),"in-progress":String(_vm.inProgress),"is-failed":String(_vm.isFailed)}})
}
var staticRenderFns = []

export { render, staticRenderFns }